/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileKeynote32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path
                fill="#007AFF"
                d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill={vars.white}
                d="M20.904 19.137a.413.413 0 01-.086.112l-.114.085H10.205a.479.479 0 01-.2-.197.468.468 0 010-.131v-.562H21v.562a.45.45 0 01-.096.13zm-10.699-1.161s.134-2.351.173-3.147v-.375a1.321 1.321 0 010-.187.6.6 0 01.057-.178.62.62 0 01.115-.15.63.63 0 01.335-.16h.735v-.524a1.743 1.743 0 010-.243.772.772 0 01.24-.46.69.69 0 01.19-.121.912.912 0 01.278-.084h1.415a.15.15 0 00.124 0l.153-.207a.457.457 0 01.115-.093l.153-.047h1.32l.152.047a.487.487 0 01.23.225.546.546 0 01.057.15c.006.05.006.1 0 .15a.918.918 0 010 .215.536.536 0 01-.057.15.54.54 0 01-.23.224l-.153.057h-1.319a.612.612 0 01-.153-.047l-.096-.066-.153-.159a.163.163 0 00-.114-.066H12.29a.331.331 0 00-.134.132.294.294 0 000 .093.973.973 0 000 .169v.534h7.907a.63.63 0 01.335.159.582.582 0 01.114.15.6.6 0 01.058.178c.005.062.005.125 0 .187v.3c0 .608.172 3.212.172 3.212H10.205v-.018zm2.869 6.087h1.912V19.85h.956v4.214h1.912c.264 0 .478.21.478.469a.473.473 0 01-.478.468h-4.78a.473.473 0 01-.478-.468c0-.259.214-.469.478-.469z"
            />
        </g>
    </AccessibleSVG>
);

export default FileKeynote32;
